export const VnLocalizedStrings = {
  GlobalLabels: {
    Other: "Khác",
    Store: "Cửa hàng",
    Staff: "Nhân viên",
    Code: "Mã",
    Welcome: "Đăng nhập CMS",
    Balance: "Hạn mức",
    Authorize: "Uỷ quyền",
    Carrier: "Nhà mạng",
    Currency: "Tiền tệ",
    Topup: "Nạp",
    STT: "STT",
    All: "Tất cả",
    SelectAll: "Chọn tất cả",
    DeselectAll: "Bỏ chọn tất cả",
    DeleteAll: "Xóa tất cả",
    NoSort: "Không có",
    Close: "Đóng",
    Status: "Trạng thái",
    Phone: "Số điện thoại",
    Actions: "Hành động",
    Active: "Hoạt động",
    Inactive: "Không hoạt động",
    Deleted: "Xóa",
    TakePicture: "Chụp ảnh",
    Noti: "Thông báo",
    Search: "Tra cứu",
    Position: "Vị trí",
    Redo: "Xóa bộ lọc",
    Filter: "Bộ lọc",
    CardView: "Dạng thẻ",
    TableView: "Dạng bảng",
    Cancel: "Hủy",
    Error: "Có lỗi xảy ra. Vui lòng thử lại",
    Confirmed: "Xác nhận",
    HoldToConfirm: "Nhấn giữ để xác nhận",
    Detail: "Chi tiết",
    Create: "Thêm mới",
    Password: "Mật khẩu",
    NewPassword: "Mật khẩu mới",
    PasswordConfirmed: "Xác nhận mật khẩu",
    Description: "Mô tả",
    Update: "Cập nhật",
    Address: "Địa chỉ",
    Partner: "Đối tác",
    PartnerCode: "Mã đối tác",
    Total: "Tổng cộng",
    NoPartner: "Không thuộc đối tác",
    createdAt: "Ngày tạo",
    updatedAt: "Ngày cập nhật",
    Cover: "Ảnh nền",
    Success: "Thành công",
    Failed: "Thất bại",
    Date: "Ngày",
    Week: "Tuần",
    Month: "Tháng",
    Hour: "Giờ",
    ExcelExporting: "Xuất Excel",
    Type: "Loại",
    Name: "Tên",
    Fullname: "Họ và tên",
    Regions: "Vùng",
    Login: "Đăng nhập",
    NoInfo: "Không có thông tin",
    ASC: "Tăng dần",
    DESC: "Giảm dần",
    Logout: "Đăng xuất",
    Attention: "Xem lưu ý tại đây",
    ReloadImages: "Làm mới ảnh",
    DownloadImage: "Tải ảnh",
    DownloadZip: "Tải file zip",
    Placeholder: "Nhập ",
    Choose: "Chọn ",
    Images: "Hình ảnh",
    UserName: "Tên tài khoản",
    Email: "Email",
    Order: "STT",
    Loading: "Loading...",
    Time: "Thời gian",
    Yes: "Có",
    No: "Không",
    Download: "Tải xuống",
    User: "Người dùng",
    Config: "Cấu hình",
    Save: "Lưu",
    Edit: "Chỉnh sửa",
    Supplier: "Nhà cung cấp",
    SupplierType: "Loại NCC",
    Import: "Nhập",
    ChangeStatus: "Đổi trạng thái",
    AccountManagement: "Quản lý tài khoản",
    ResetPassword: "Đặt lại mật khẩu",
    Tools: "Công cụ",
    Reason: "Lý do",
    RefreshFeature: "Làm mới quyền truy cập",
    RefreshCache: "Làm mới dữ liệu lưu tạm",
    DownloadTransactionGuide: "Tải file hướng dẫn",
    GeneralInfo: "Tổng quan",
    PackageRefresh: "Làm mới danh sách gói",
  },
  GlobalMessage: {
    RightClickCopy: "Chuột phải để sao chép",
    ApproveAksing: "Bạn xác nhận duyệt phần tử này ?",
    Email: "Nhập đúng định dạng Email !",
    UpdateSuccessfully: "Cập nhật thành công !",
    UpdateFailed: "Cập nhật thất bại:",
    CreateSuccessfully: "Tạo mới thành công !",
    CreateFailed: "Tạo mới thất bại:",
    DeleteSuccessfully: "Xóa thành công !",
    DeleteFailed: "Xóa thất bại:",
    DeleteConfirmation: "Xác nhận xóa phần tử này ?",
    DeleteConfirmationWithName: 'Bạn có chắc chắn muốn xóa "{name}"?',
    ResetPassSuccessfully: "Đặt lại mật khẩu thành công !",
    ResetPassFailed: "Đặt lại mật khẩu thất bại:",
    Error: "Đã có lỗi xảy ra",
    Exporting: "Đang xuất Báo cáo...",
    SystemError:
      "Có lỗi lấy thông tin đăng nhập hoặc token hết hạn, quay lại trang đăng nhập...",
    LoginSuccessfully: "Đăng nhập thành công !",
    InvalidAccount:
      "Tên tài khoản hoặc mật khẩu không đúng hoặc User không tồn tại !",
    InvalidMenuConfig:
      "Lỗi không lấy được Menu Sidebar, vui lòng thử lại sau !",
    Supplier: "Vui lòng nhập Mã tham chiếu",
    ChooseSupplier: "Vui lòng chọn Nhà cung cấp",
    Required: "Vui lòng nhập thông tin này",
    CannotAccessCam: "Không thể truy cập máy ảnh",
    SavingForLogin: "Giữ cho lần đăng nhập tiếp theo",
    SavedToClipboard: "Đã lưu giá trị vào bộ nhớ tạm.",
    InvalidStore: "Chọn một cửa hàng",
    InvalidToken:
      "Token không khả dụng hoặc không tồn tại, quay lại Đăng nhập...",
    PasswordNotMatch: "Mật khẩu không trùng khớp",
    PasswordLength: "Mật khẩu phải từ 6 ký tự trở lên",
    ResetPassMessage: "Bạn có muốn đổi mật khẩu cho người dùng này không?",
    SyncOnProcess: "Đang đồng bộ trạng thái, vui lòng đợi...",
    NotAllowedToUse: "Cần cấp quyền",
    RefreshFeatureSuccessfully: "Đã làm mới quyền truy cập của tài khoản !",
    NotFoundPath: "Không tìm thấy đường dẫn hoặc không có quyền truy cập",
    AlreadyHasCopied: "Đã có giá trị trong bộ nhớ tạm",
    ResetOTPMessage: "Bạn có muốn đặt lại OTP cho người dùng này không?",
    SearchPlaceholder: "Nhập từ khóa để tìm kiếm",
    ExcelError: "Lỗi xuất file: Sai định dạng hoặc không có dữ liệu",
    NeedPermisson: "Vui lòng cấp quyền truy cập bộ nhớ tạm",
    PermissonSuccess: "Đã cấp quyền truy cập bộ nhớ tạm",
    SignUp: "Đăng ký tài khoản",
    Url: "Nhập giá trị dưới định dạng URL",
    PositiveNumber: "Nhập giá trị từ 0 trở lên...",
    Currency: "Nhập giá tiền ít nhất 1,000 VND",
    PleaseWait: "Vui lòng chờ trong giây lát...",
  },
  GlobalPlaceholder: {
    UserName: "Nhập tên tài khoản",
    Currency: "Chọn tiền tệ",
    Email: "Vui lòng nhập email...",
    Name: "Vui lòng nhập tên...",
    Code: "Vui lòng nhập mã...",
    Partner: "Vui lòng chọn đối tác",
    Status: "Vui lòng chọn trạng thái",
    Phone: "Vui lòng nhập số điện thoại...",
    Password: "Nhập mật khẩu",
    PasswordConfirmed: "Mật khẩu xác nhận cần trùng với mật khẩu",
    Description: "Vui lòng nhập mô tả là chữ",
    Type: "Vui lòng chọn loại",
    SearchByCode: "Tìm bằng mã gói",
  },
  GlobalTotalSummary: {
    Success: "Thành công",
    Error: "Thất bại",
    Other: "Khác",
    USD: "Doanh thu ngoại tệ",
    VND: "Doanh thu nội tệ",
    Revenue: "Tổng doanh thu",
  },
  GlobalService: {
    ALL: "Tất cả",
    TRAVEL_SIM: "SIM Du lịch",
    IOT_SIM: "SIM IoT",
    NICE_SIM: "SIM Số đẹp",
    BUY_PACKAGE: "Gói cước",
    SIM_ECOMMERCE: "SIM",
    AIR_TIME: "Nạp tiền ĐT",
    ADD_BALANCE: "Nạp số dư",
    GOGO_SIM: "SIM Gogo",
  },
  Role: {
    SuperAdmin: "Super Admin",
    Admin: "Admin",
    Accountant: "Kế toán",
    User: "Người dùng",
  },
  TopupInfo: {
    Company: "Công ty TNHH Thương mại – Dịch vụ Phương Quân",
    AccountNumber: "8600617979",
    SwiftCode: "",
    Title: "Thông tin chuyển khoản",
    AccountName: "Tên tài khoản",
    AccountNo: "Số tài khoản",
    Bank: "Ngân hàng",
    BankName: "Ngân Hàng TMCP Đầu tư và Phát triển Việt Nam - CN Bắc Sài Gòn",
    BankAddress:
      "290 Nam Kỳ Khởi Nghĩa, Phường Xuân Hòa, TP Hồ Chí Minh, Việt Nam",
    BankBranch: "Thủ Thiêm, PGD Cao Thắng",
  },
  Sidebar: {
    General: "Tổng quan",
    Management: "Quản lý",
    History: "Lịch sử giao dịch",
    DataTransaction: "Gói cước",
    SystemConfig: "Cấu hình",
    DataPackages: "Gói cước Data",
    RoamingPackages: "Gói cước Roaming",
    UserManagement: "Người dùng",
    AffiliateManagement: "Quản lý affiliate",
    OrderList: "Đơn hàng mua SIM",
    TravelSimList: "Đăng ký SIM Du lịch",
    Country: "Quốc gia",
    PlatformConfig: "Platform",
    Contents: "Bài viết",
    Files: "Tệp",
    CDN: "CDN",
    Address: "Tỉnh thành",
    TopUpForPackage: "Gói cước 4G/5G",
    TopupForSimEcommerce: "Gói cước SIM Mobifone",
    TopUpForTravelService: "Gói cước SIM Du lịch",
    Suppliers: "Nhà cung cấp",
    RegisterHistory: "Lịch sử đăng ký",
    IoTSupport: "Hỗ trợ IoT",
  },
  General: {
    Title: "Tổng quan",
    Summary: "Tổng quan hoạt động kinh doanh",
    ByDate: "Theo ngày",
    ByWeek: "Theo tuần",
    ByMonth: "Theo tháng",
    ByCurrency: "Theo tiền tệ",
    Catalogue: "Danh mục",
    Revenue: {
      Label: "Doanh thu",
      CompareWith: "so với",
      Transaction: "Sản lượng",
      CurrentDate: "hôm nay",
      CurrentMonth: "tháng này",
      LastMonth: "tháng trước đó",
      PreviousDate: "ngày hôm qua",
      LastMonthDate: "tháng trước",
      LastMonthBefore: "tháng trước đó",
      Day: "Doanh thu hôm nay",
      Week: "Doanh thu tuần này",
      Month: "Doanh thu tháng này",
      WeekOfYear: "Tuần",
    },
    Charts: {
      Title: "Báo cáo tổng hợp",
      Transaction: "Giao dịch",
      TotalRevenue: "Tổng doanh thu",
      SuccessTransaction: "Tổng giao dịch thành công",
    },
  },
  ErrorCodeGeneral: {
    Title: "Thống kê lỗi",
    List: "Danh sách mã lỗi",
    LongMessage: "Nội dung: ",
    Summary: "Thống kê các lỗi của hoạt động kinh doanh",
    ByDate: "Theo ngày",
    ByWeek: "Theo tuần",
    ByMonth: "Theo tháng",
    Tab: {
      0: "Mã lỗi",
      1: "Sản phẩm",
      2: "Nhà mạng",
    },
    Transaction: {
      Label: "Sản lượng lỗi",
      CompareWith: "so với",
      CurrentDate: "hôm nay",
      CurrentMonth: "tháng này",
      LastMonth: "tháng trước đó",
      PreviousDate: "ngày hôm qua",
      LastMonthDate: "tháng trước",
      Day: "Sản lượng hôm nay",
      Week: "Sản lượng tuần này",
      Month: "Sản lượng tháng này",
      WeekOfYear: "Tuần",
    },
  },
  UserManagement: {
    MainTitle: "Người dùng hệ thống",
    B2CTitle: "Người dùng B2C",
    B2BTitle: "Người dùng B2B",
    Total: "Tổng User",
    UserType: {
      Agency: "User chuỗi",
      Store: "User cửa hàng",
      Employee: "User nhân viên",
    },
    AllType: {
      0: "Cơ bản",
      1: "Super Admin",
      3: "User chuỗi",
      4: "User cửa hàng",
      5: "User nhân viên",
      6: "User vãng lai",
    },
    StaffColumns: {
      name: "Tên",
      fullName: "Họ tên",
      code: "Mã",
      phone: "Số điện thoại",
      email: "Email",
      address: "Địa chỉ",
      store: "Thuộc cửa hàng",
      parent: "Nhân viên của",
      partner: "Thuộc đối tác",
      wallet: "Hạn mức (VND)",
      type: "Loại",
      platform: "Platform",
      status: "Trạng thái",
      createdAt: "Ngày tạo",
    },
    B2CUserCreate: {
      userName: "Tên tài khoản",
      name: "Tên",
      email: "Email",
      fullName: "Họ và tên",
      birthDay: "Ngày sinh",
      phone: "Số điện thoại",
      type: "Loại",
      status: "Trạng thái",
      partner: "Đối tác",
      stores: "Thuộc cửa hàng",
      platform: "Platform",
      role: "Role",
      avatar: "Avatar",
      confirmPayment: "Phương thức xác thực thanh toán", //0: Password, 1: OTP
      taxCode: "Mã số thuế",
      parent: "Trực thuộc Người dùng ?",
      isVerified: "Đã xác thực ?", //boolean
    },
    Columns: {
      UserName: "Tên tài khoản",
      FullName: "Họ tên",
      Email: "Email",
      Partner: "Đối tác",
      Phone: "Số điện thoại",
      Balance: "Số dư",
      Role: "Role user",
      ResetPass: "Đặt mật khẩu mới",
      OldPass: "Mật khẩu cũ",
      NewPass: "Mật khẩu mới",
      UpdateStatus: "Đổi trạng thái",
      CreatedAt: "Ngày tạo",
      Code: "Mã",
      Referents: "Nhà cung cấp",
    },
    RuleMessage: {
      Url: "Vui lòng nhập giá trị dưới dạng URL",
      Name: "Vui lòng nhập tên",
      Password: "Vui lòng nhập mật khẩu",
      UserName: "Vui lòng nhập tên tài khoản",
      IdUrl: "Vui lòng nhập link tiếp thị",
      IconUrl: "Vui lòng nhập link icon có định dạng jpg, png, jpeg",
      Status: "Vui lòng chọn trạng thái",
      Phone: "Vui lòng nhập số điện thoại gồm 10 chữ số",
      Code: "Vui lòng nhập mã",
      Role: "Vui lòng chọn role cho user",
      Partner: "Vui lòng chọn đối tác",
      InvalidPartner: "Đối tác không hợp lệ",
      Balance: "Vui lòng nhập hạn mức",
      InvalidUserStore: "Chọn một User cửa hàng",
      InvalidUserChain: "Chọn một User chuỗi",
      InvalidReference: "Chọn một nhà cung cấp",
    },
    Labels: {
      Account: "Tài khoản",
      Address: "Địa chỉ",
      Note: "Ghi chú",
      Description: "Mô tả",
      UserFeatures: "TÍnh năng tùy chỉnh cho người dùng",
    },
  },
  UserFeatures: {
    Title: "Tính năng người dùng",
    Columns: {
      Name: "Tên",
      Code: "Mã",
      Path: "Đường dẫn API",
    },
  },
  PathConfigManagement: {
    Title: "Quản lý cấu hình",
    Total: "Tổng cộng",
    Columns: {
      Title: "Tên cấu hình",
      Code: "Mã cấu hình",
      Path: "Đường dẫn",
      ImageUrl: "Hình ảnh",
      Description: "Mô tả",
    },
    Placeholder: {
      Title: "Vui lòng nhập tên",
      Path: "Vui lòng nhập đường dẫn",
      ImageUrl: "Vui lòng nhập link hình ảnh dạng URL",
      Description: "Vui lòng nhập mô tả",
    },
    Message: {
      AddConfig: "Vui lòng khai báo cấu hình JSON bên dưới",
    },
  },
  ContentManagement: {
    Title: "Quản lý bài viết",
    Total: "Tổng bài viết",
    Columns: {
      Name: "Tên bài viết",
      Preview: "Xem trước",
      Replace: "Thay bài viết",
      Download: "Tải bài viết",
      Delete: "Xóa bài viết",
      File: "Tệp bài viết",
      Image: "Hình ảnh",
    },
    Message: {
      WrongStructure: "File tải không đúng định dạng !",
      NotExisted: "File tải không tồn tại !",
      Files: "Vui lòng nhập ít nhất một file bài viết",
      OnlyDocx: "Lưu ý: Chỉ nhập file DOCX",
      OnlyImages: " Lưu ý: Chỉ nhập 1 file ảnh PNG, JPEG, JPG",
      MissingAttributes:
        "Vui lòng đặt tên có tiền tố Content đối với file DOC hoặc Image đối với file ảnh !",
      AddAttribute:
        "Vui lòng đặt tên file bài viết có tiền tố Content (Content_abc.docx), file hình ảnh có tiền tố Image (Image_xyz.png)",
    },
  },
  CountryManagement: {
    Title: "Quản lý quốc gia",
    Total: "Tổng quốc gia",
    Columns: {
      Name: "Tên quốc gia",
      Code: "Mã quốc gia",
      Capital: "Thủ đô",
      Region: "Vùng",
      Ensign: "Quốc kỳ",
    },
    Regions: {
      Americas: "Americas",
      Europe: "Europe",
      Asia: "Asia",
      Africa: "Africa",
      Oceania: "Oceania",
      Antarctica: "Antarctica",
    },
    Placeholder: {
      Capital: "Vui lòng nhập tên thủ đô",
      Region: "Vui lòng chọn vùng quốc gia",
      Cover: "Vui lòng nhập link hình ảnh dưới dạng URL",
    },
    RoamingPartner: {
      Name: "Tên đối tác",
      Code: "Mã đối tác",
    },
    MobileData: {
      Name: "Tên gói cước",
      Code: "Mã gói cước",
      Price: "Giá gói",
      Handset: "Handset",
      TransferredData: "Nhóm dữ liệu",
      CodeMobileDevice: "Code Mobile Device",
    },
    Message: {
      CoverAttributes: "Vui lòng chọn file ảnh nền",
      EnsignAttributes: "Vui lòng chọn một file ảnh quốc kỳ",
      Name: "Nhập tên quốc gia (VD: Vietnam)",
      Code: "Nhập mã quốc gia",
      Capital: "Nhập thủ đô (VD: Hanoi)",
      Region: "Chọn vùng quốc gia",
    },
  },
  FileManagement: {
    Title: "Quản lý CDN",
    Upload: "Nhập File",
    Replace: "Thay file",
    Download: "Tải file",
    CopyUrl: "Sao chép URL",
    Placeholder: {
      Type: "Vui lòng chọn loại file",
      File: "Vui lòng nhập ít nhất 1 file từ máy tính",
      Url: "Đã lưu URL vào bộ nhớ tạm",
      SavedValue: "Đã lưu giá trị vào bộ nhớ tạm",
    },
    Columns: {
      Name: "Tên file",
      Code: "Mã file",
      Size: "Kích thước",
      Type: "Loại tệp",
    },
  },
  RoamingManagement: {
    Title: "Quản lý Gói Roaming",
    Total: "Tổng gói Roaming",
    Add: "Thêm",
    DetailInfo: "Thông tin chi tiết gói",
    RoamingPartnerInfo: "Thông tin đối tác Roaming",
    Category: {
      Hot: "Gói hot",
      Day: "Gói ngày",
      Week: "Gói tuần",
      Month: "Gói tháng",
      Roaming: "Gói Roaming",
    },
    PlaceHolder: {
      Cover: "Vui lòng nhập url hình ảnh...",
      Descriptions: "Vui lòng nhập mô tả...",
      ShortDes: "Vui lòng nhập mô tả ngắn gọn...",
      Duration: "Vui lòng nhập thời lượng gói...",
      Price: "Vui lòng nhập giá gói...",
      Storage: "Vui lòng nhập dung lượng gói...",
      DiscountRate: "Vui lòng nhập giảm giá...",
      InternalCallTotalHour: "Vui lòng nhập giờ gọi nội mạng...",
      ExternalCallTotalHour: "Vui lòng nhập giờ gọi ngoại mạng...",
      Category: "Vui lòng chọn loại gói...",
      Country: "Vui lòng chọn quốc gia...",
    },
    Country: {
      Title: "Quốc gia",
      Add: "Thêm quốc gia",
      Edit: "Chỉnh sửa thông tin quốc gia",
    },
    RoamingPartner: {
      Title: "Đối tác",
      Add: "Thêm đối tác",
      Select: "Chọn đối tác",
    },
    Columns: {
      Name: "Tên gói",
      Code: "Mã",
      Cover: "Hình ảnh",
      Description: "Mô tả",
      ShortDescription: "Mô tả ngắn gọn",
      Duration: "Thời lượng gói",
      Price: "Giá",
      Storage: "Dung lượng",
      DiscountRate: "Giảm giá",
      InternalCallTotalHour: "Giờ gọi nội mạng",
      ExternalCallTotalHour: "Giờ gọi ngoại mạng",
      Action: "Hành động",
      Country: "Quốc gia",
      Region: "Khu vực",
      Category: "Loại gói",
      Order: "Thứ tự",
      Type: "Loại",
      SimType: "Loại SIM",
      OnlyData: "Chỉ có data",
    },
  },
  TopupManagement: {
    Title: "Quản lý gói cước Data",
    Total: "Tổng gói cước",
    PriceRange: "Khoảng giá",
    Add: "Thêm thông tin",
    AddShort: "Thêm mô tả ngắn",
    AddMore: "Thêm thông tin mở rộng cho gói",
    More: "Thông tin mở rộng cho gói",
    MoreInfoName: "Tên thông tin",
    MoreInfoItems: "Thông tin",
    ShortDescription: "Mô tả ngắn",
    Order: "Theo độ ưu tiên",
    OnlyData: "Chỉ có Data ?",
    SimType: "Gói cho SIM ?",
    MoreWithTag: "Tag cho gói",
    TopLeftTitle: "Tiêu đề cho Tag",
    IsHot: "Là gói HOT ?",
    IsMobileTag: "Có Tag cho gói ?",
    Generals: "Thông tin gói",
    CountryInfo: "Quốc gia",
    Columns: {
      Name: "Tên gói",
      Code: "Mã gói",
      Order: "Độ ưu tiên",
      DurationDay: "Thời hạn",
      Price: "Giá gói",
      Storage: "Dung lượng",
      Category: "Danh mục gói",
      InternalCallTotalHour: "Gọi nội mạng",
      ExternalCallTotalHour: "Gọi ngoại mạng",
    },
    Category: {
      Hot: "Gói hot",
      Day: "Gói ngày",
      Week: "Gói tuần",
      Month: "Gói tháng",
    },
    Placeholder: {
      DurationDay: "Vui lòng nhập thời lượng gói",
      Price: "Vui lòng nhập giá gói thấp nhất 1,000 VNĐ !",
      Storage: "Vui lòng nhập dung lượng là số !",
      Cover: "Vui lòng nhập link dưới dạng URL !",
      Category: "Vui lòng chọn loại gói cước",
      DesAuto: "Nhập mô tả ngắn để có thể tự cập nhật mô tả",
      AutoUpdate: "Cập nhật cho cả Mô tả",
      RoamingIsRequired: "Chỉ có thể truy cập Quốc gia khi Loại là Roaming",
      UpdateCountry: "Tùy chỉnh thông tin Quốc gia cho gói Roaming",
      DuplicatedCode: "Mã gói cước nhà cung cấp này đã tồn tại",
    },
    SyncFromB2B: {
      Title: "Thêm gói data từ B2B",
      Confirm: "Bạn có chắc chắn muốn thêm các gói",
      InvalidPackages: "Vui lòng chọn một gói cước",
    },
    Service: {
      BuyPackage: "Data 4G/5G",
      TravelSim: "SIM Du lịch",
      SimEcommerce: "SIM Mobifone",
    },
  },
  TransactionHistory: {
    Title: "Lịch sử giao dịch gói cước",
    Total: "Tổng giao dịch",
    NoTransRef: "Không mã tham chiếu",
    Customer: "Khách hàng mua lẻ",
    Details: "Chi tiết giao dịch",
    StatusCheck: "Kiểm tra trạng thái",
    Message: {
      PartnerListError: "Lỗi danh sách đối tác",
    },
    Status: {
      Init: "Khởi tạo",
      Progerssing: "Đang xử lý",
      Finished: "Hoàn thành",
      Error: "Lỗi",
      Deleted: "Đã xóa",
      WaitingToBeConfirmed: "Chờ xác nhận",
    },
    Placeholder: {
      Code: "Nhập mã giao dịch",
      ID: "Nhập ID giao dịch",
      TransRef: "Nhập mã tham chiếu",
    },
    Columns: {
      ID: "ID giao dịch",
      Code: "Mã giao dịch",
      TransRef: "Mã tham chiếu",
      PackageName: "Gói cước",
      Phone: "Số điện thoại",
      Partner: "Đối tác",
      Method: "Phương thức",
      TotalAmount: "Tổng tiền",
    },
  },
  AddressManagement: {
    Title: "Quản lý Tỉnh thành",
    DataType: "Dữ liệu danh sách",
    Province: "Danh sách Tỉnh, Thành phố lớn",
    District: "Danh sách Quận, Huyện",
    Wards: "Danh sách Phường, Xã",
    Columns: {
      Name: "Tên",
      Code: "Mã",
      FullName: "Tên đầy đủ",
      FullNameEn: "Tên tiếng Anh đầy đủ",
      Province: "Tỉnh, thành phố lớn",
      District: "Quận, huyện",
      NameEn: "Tên tiếng Anh",
      Ward: "Phường, xã",
    },
    Placeholder: {
      Units: "Vui lòng chọn loại",
      Regions: "Vui lòng chọn vùng",
    },
  },
  ChangePassword: {
    Title: "Đổi mật khẩu",
    OldPass: "Mật khẩu cũ",
    NewPass: "Mật khẩu mới",
    Reconfirmed: "Xác nhận mật khẩu mới",
    Message: {
      InvalidPass: "Vui lòng xác nhận mật khẩu",
      OldPass: "Vui lòng nhập mật khẩu cũ",
      NewPass: "Vui lòng nhập mật khẩu mới",
      UnmatchedPass: "Mật khẩu xác nhận không trùng khớp",
      ChangePassSucceed: "Bạn đã đổi mật khẩu thành công !",
    },
  },
  SimOrdersForPartners: {
    Title: "Danh sách thông tin đăng ký Sim",
    Columns: {
      CreatedAt: "Thời gian tạo",
      OrderCode: "Mã đơn hàng",
      Sim: "Số Sim",
      PackageType: "Loại gói",
      CustomerName: "Tên khách hàng",
      CustomerPhone: "Số điện thoại khách hàng",
      Address: "Địa chỉ giao hàng",
      Email: "Email khách hàng",
      Partner: "Đối tác",
    },
    Status: {
      WaitingForPurchased: "Chờ thanh toán",
      WaitingForDelivered: "Chờ giao hàng",
      WaitingForRecieved: "Chờ nhận hàng",
      Success: "Giao hàng thành công",
      Canceled: "Đã hủy",
      ConnectedSuccessfully: "Hòa mạng thành công",
      ConnectedFailed: "Hòa mạng thất bại",
    },
    Message: {
      ExcelError: "Lỗi xuất báo cáo",
      InvalidSim: "Số sim không được để trống",
      InvalidPackages: "Nhập số sim để hiện thông tin gói",
      InvalidOrderCode: "Mã đơn hàng không để trống",
      InvalidPhone: "Điện thoại liên hệ không được trống hoặc quá 10 số !",
      Address: "Vui lòng nhập địa chỉ khách hàng",
    },
  },
  TravelSimListManagement: {
    Title: "Danh sách thông tin đăng ký SIM du lịch",
    Placeholder: "Vui lòng nhập ",
    Detail: "Thông tin chi tiết",
    Gender: {
      Male: "Nam",
      Female: "Nữ",
    },
    Labels: {
      Status: "Trạng thái",
      Type: "Loại",
      Name: "Tên khách hàng",
      ProfileId: "Mã hồ sơ",
      Serial: "Số serial",
      Sim: "Số sim",
      Detail: "Chi tiết",
      Time: "Thời gian tạo",
      IdNumber: "Mã định danh",
      Birthday: "Ngày sinh",
      Sex: "Giới tính",
      Address: "Địa chỉ",
      PlaceOfOrigin: "Quê quán",
      IssueDate: "Ngày cấp",
      IssuePlace: "Nơi cấp",
      PhoneContact: "Số điện thoại",
      EmailContact: "Email",
      ImagesPath: "Các loại giấy tờ",
    },
    ImagePaths: {
      portrait: "Ảnh chân dung",
      front: "Mặt trước",
      back: "Mặt sau",
      sign: "Chữ ký",
    },
    Status: {
      init: "Khởi tạo",
      isOCR: "Đã OCR",
      verified: "Đã xác thực",
      progress: "Đang xử lý",
      success: "Thành công",
      error: "Thất bại",
    },
    Type: {
      cccd: "CCCD",
      passport: "Hộ chiếu",
    },
  },
  RoamingRegistration: {
    Title: "Đăng ký gói cước cho User",
    ModalTitle: "Đăng ký gói cước cho thuê bao",
    Action: "Chọn gói",
    Phone: "Thuê bao cần đăng ký",
    Register: "Đăng ký",
    AddToList: "Thêm vào danh sách đăng ký",
    AssingedList: "Danh sách đăng ký",
    PhoneRegisteredListColumns: {
      Name: "Tên khách hàng",
      Phone: "Thuê bao đăng ký",
      Address: "Địa chỉ",
      Price: "Tổng tiền",
      Email: "Email",
    },
    Columns: {
      Name: "Tên gói",
      Code: "Mã gói",
      Type: "Loại gói",
      Duration: "Thời hạn",
      Capacity: "Dung lượng",
      Price: "Giá gói",
      PartnerTransId: "Mã tham chiếu của đối tác",
    },
    Placehoder: {
      Phone: "Vui lòng nhập số điện thoại...",
    },
    Message: {
      Success: "Đăng ký gói cước thành công",
      Failed: "Đăng ký gói cước cho thuê bao thất bại",
      Error: "Có lỗi xảy ra",
      InvalidPackageAndPhone:
        "Vui lòng chọn một gói cước và nhập thuê bao cần đăng ký để đi tiếp !",
      InvalidPackage: "Vui lòng chọn một gói cước !",
      InvalidPhone: "Vui lòng nhập số thuê bao cần đăng ký gói !",
      RegisterSuccessfully: "Đăng ký gói cước cho thuê bao thành công !",
      PhoneRegistrationWarning:
        "Đây là danh sách tham khảo, vui lòng tìm kiếm với số thuê bao cần đăng ký để hiện danh sách gói phù hợp",
      PhoneRegistrationConfirm: "Xác nhận đăng ký gói",
      ForPhone: "cho thuê bao",
      BasePackagesExisted: "Thuê bao cần đăng ký đang có gói nền",
      RemoveBasePackages: "vui lòng hủy gói nền trước khi đăng ký gói mới !",
      PackagesForSearchedPhone: "Danh sách gói cước cho thuê bao",
      NotMobifone: "Thuê bao không thuộc đầu số Mobifone, vui lòng thử lại !",
      EmptyAssignedList: "Danh dách đăng ký đang rỗng !",
      InvalidPartnerTransId: "Vui lòng nhập mã tham chiếu đối tác !",
      InvalidPhoneLength: "Vui lòng nhập số điện thoại đủ 10 số !",
    },
  },
  BalanceHistory: {
    Title: "Lịch sử điều chỉnh số dư",
    Approve: "Duyệt",
    Reject: "Từ chối",
    Add: "Tạo phiếu",
    Type: {
      1: "Phiếu giảm",
      2: "Phiếu tăng",
      3: "Phiếu hoàn tiền",
    },
    Status: {
      0: "Đang chờ duyệt",
      2: "Duyệt",
      3: "Lỗi",
      9: "Từ chối",
    },
    ApplicableType: {
      0: "Người dùng",
      1: "Đối tác",
    },
    Transaction: {
      code: "Mã giao dịch",
      service: "Dịch vụ",
    },
    Placeholder: {
      Type: "Vui lòng chọn loại phiếu",
      ApplicableType: "Vui lòng chọn đối tượng áp dụng",
      Amount: "Vui lòng nhập số tiền yêu cầu ít nhất 1000 VNĐ",
      Phone: "Chọn người dùng hoặc đối tác để lấy số điện thoại",
      Partner: "Vui lòng chọn một đối tác",
      User: "Vui lòng chọn một người dùng",
    },
    Columns: {
      code: "Mã phiếu",
      phoneNumber: "Số điện thoại",
      partnerName: "Tên đối tác",
      partnerCode: "Mã đối tác",
      providerCode: "Nhà cung cấp",
      totalPrice: "Số tiền yêu cầu",
      beforeCredit: "Số dư trước khi duyệt",
      afterCredit: "Số dư sau khi duyệt",
      applicableType: "Đối tượng áp dụng",
      type: "Loại",
      status: "Trạng thái",
      createdBy: "Người tạo",
      updatedBy: "Người duyệt",
      name: "Lý do",
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
    },
    Message: {
      CreateSuccessfully: "Tạo phiếu thành công !",
      CreateFailed: "Tạo phiếu thất bại !",
      ApproveSuccessfully: "Duyệt phiếu thành công !",
      ApproveFailed: "Duyệt phiếu thất bại",
      RejectSuccessfully: "Từ chối phiếu thành công !",
      RejectFailed: "Từ chối phiếu thất bại",
      ConfirmedReject: "Xác nhận từ chối phiếu ?",
      ConfirmApprove: "Xác nhận duyệt phiếu ?",
    },
  },
  PermissionData: {
    Title: "Menu truy cập",
    Columns: {
      code: "Mã menu",
      name: "Tên menu",
      displayName: "Tên hiển thị",
      componentName: "Tên component",
      path: "Đường dẫn",
      parent: "Thuộc menu ?",
      capabilities: "Các tính năng",
      key: "Từ khóa",
      roles: "Role áp dụng",
      users: "Người dùng áp dụng",
      type: "Loại",
      status: "Trạng thái",
      order: "Thứ tự",
      icon: "Link menu icon",
      description: "Mô tả",
      createdAt: "Ngày tạo",
    },
    Detail: {
      roles: "Vai trò",
      users: "Người dùng",
      capabilities: "Tính năng truy cập",
      configuration: "Cấu hình",
    },
    Placeholder: {
      code: "Nhập mã...",
      name: "Nhập tên...",
      componentName: "Nhập tên component...",
      path: "Nhập đường dẫn...",
    },
    Status: {
      0: "Hoạt động",
      1: "Không hoạt động",
      2: "Đã xóa",
    },
  },
  UserPermission: {
    Title: "Quyền truy cập",
    Columns: {
      code: "Mã quyền",
      name: "Tên quyền",
      path: "Đường dẫn",
      users: "Người dùng được cấp phép",
      blackList: "Người dùng bị chặn",
      permissionStatus: "Trạng thái quyền",
      status: "Trạng thái",
      type: "Loại",
      order: "Thứ tự",
      note: "Ghi chú",
      isLog: "Ghi log",
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
    },
    Detail: {
      users: "Người dùng áp dụng",
      configuration: "Cấu hình",
      capabilities: "Các tính năng truy cập",
      allowed: "Cấp phép",
      blocked: "Bị chặn",
      moveToBlackList: "Cho vào Danh sách chặn",
      reAllow: "Cấp phép lại",
    },
    Placeholder: {
      code: "Nhập mã quyền...",
      name: "Nhập tên quyền...",
      path: "Nhập đường dẫn...",
    },
    Status: {
      0: "Hoạt động",
      1: "Không hoạt động",
      2: "Đã xóa",
    },
    Type: {
      0: "Cho quản lý",
      1: "Cho đối tác",
      2: "Cho nhà cung cấp",
      3: "Cho hooks",
      4: "Cho crawl job tự động",
    },
    Message: {
      NeedCreateCapa: "Cần tạo mới để có mã",
    },
  },
  RoleManagement: {
    Title: "Phân quyền",
    Columns: {
      code: "Mã phân quyền",
      name: "Tên phân quyền",
      status: "Trạng thái",
      order: "Thứ tự",
      maximum: "Số lượng tối đa",
      level: "Cấp độ",
      users: "Người dùng",
      menus: "Menu truy cập",
      features: "Quyền truy cập",
      note: "Ghi chú",
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
    },
    Detail: {
      users: "Người dùng",
      menus: "Menu truy cập",
      features: "Quyền truy cập",
    },
    Placeholder: {
      code: "Nhập mã...",
      name: "Nhập tên...",
    },
    Status: {
      0: "Hoạt động",
      1: "Không hoạt động",
      2: "Đã xóa",
    },
  },
  Capability: {
    Title: "Tính năng truy cập",
    Columns: {
      code: "Mã tính năng",
      name: "Tên tính năng",
      displayName: "Tên hiển thị",
      key: "Từ khóa",
      feature: "Truy cập cho",
      menus: "Menu truy cập",
      status: "Trạng thái",
      order: "Thứ tự",
      description: "Mô tả",
      note: "Ghi chú",
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
    },
    Detail: {
      configuration: "Cấu hình",
    },
    Placeholder: {
      code: "Nhập mã...",
      name: "Nhập tên...",
      key: "Nhập từ khóa...",
      menu: "Chọn menu...",
    },
    Status: {
      0: "Hoạt động",
      1: "Không hoạt động",
      2: "Đã xóa",
    },
    Type: {
      0: "API",
      1: "Menu",
      2: "Action",
    },
  },
  PartnerManagement: {
    Normal: "Normal",
    MainTitle: "Quản lý đối tác",
    ipnUrl: "IPN Url",
    IpConfig: "Whitelist IP",
    Total: "Tổng đối tác",
    IsChain: {
      Chain: "Đối tác cho Chuỗi",
      Normal: "Đối tác Affiliate",
    },
    CreateUserAfter:
      "Sau khi tạo đối tác thành công, sẽ tự động tạo một thông tin người dùng cho đối tác đó",
    UserPartner: "Thông tin người dùng cho đối tác",
    CopyUserInfo: "Đã lưu thông tin người dùng của đối tác vào bộ nhớ tạm",
    Columns: {
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      type: "Loại",
      status: "Trạng thái",
      isChain: "Kiểu đối tác",
      affiliateUrl: "Đường dẫn Affiliate",
      createdAt: "Ngày tạo",
    },
    Filters: {
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      isChain: "Kiểu đối tác",
      type: "Loại",
      status: "Trạng thái",
    },
    Detail: {
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
      id: "ID",
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      type: "Loại",
      status: "Trạng thái",
      isChain: "Kiểu đối tác",
      publicKey: "Khóa đối tác",
      taxCode: "Mã số thuế",
      whnSupplierCode: "Mã nhà cung cấp WHN",
      token: "Token",
      affiliateUrl: "Đường dẫn Affiliate",
      icon: "Đường dẫn Icon",
      address: "Địa chỉ",
      ipnUrl: "Đường dẫn IPN",
    },
    Placeholder: {
      SavedPass: "Đã lưu mật khẩu vào bộ nhớ tạm",
      SavesName: "Đã lưu tên tài khoản vào bộ nhớ tạm",
    },
    UserInfo: {
      createdAt: "Ngày tạo",
      name: "Tên",
      fullName: "Họ tên",
      userName: "Tên tài khoản",
      code: "Mã",
      phone: "Số điện thoại",
      email: "Email",
      partner: "Thuộc đối tác",
      type: "Loại",
      status: "Trạng thái",
    },
  },
  RoamingPartner: {
    Active: {
      0: "Roaming",
    },
    Label: "Đối tác Roaming",
    CountryList: "Danh sách quốc gia",
    MobileDataList: "Danh sách nhà mạng",
    Columns: {
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
      id: "ID đối tác",
      code: "Mã đối tác",
      name: "Tên đối tác",
      email: "Email",
      phone: "Số điện thoại",
      address: "Địa chỉ",
      type: "Loại",
      active: "Tình trạng kích hoạt",
      url: "Đường dẫn",
      order: "Order",
    },
    Filters: {
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      type: "Loại",
      active: "Tình trạng kích hoạt",
    },
    Detail: {
      id: "ID",
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      type: "Loại",
      active: "Tình trạng kích hoạt",
      order: "Order",
      url: "Đường dẫn",
      address: "Địa chỉ",
    },
  },
  AppProfileRegister: {
    Title: "Hợp đồng Mobitopup App",
    Labels: {
      TypeContract: "Loại người dùng",
      DownloadFiles: "Tải hình ảnh hợp đồng",
      ApprovedBy: "Người duyệt",
      DetailProfile: "Chi tiết hồ sơ",
      VerifyProfile: "Duyệt hồ sơ",
      AcceptProfile: "Chấp nhận hồ sơ",
      AcceptConfirm: "Bạn có muốn chấp nhận hồ sơ này?",
      DenyProfile: "Từ chối hồ sơ",
      DenyConfirm: "Bạn có muốn từ chối hồ sơ này?",
      RejectReason: "Lý do từ chối",
      SignProfile: "Ký hồ sơ",
      Id: "ID hồ sơ",
      Status: "Trạng thái",
      Type: "Loại hợp đồng",
      Name: "Tên hồ sơ",
      Code: "Mã hồ sơ",
      Time: "Thời gian tạo",
      UpdatedTime: "Thời gian cập nhật",
      ProviderCode: "Mã định danh hồ sơ",
      ProviderPreviewCode: "Mã hồ sơ nhà cung cấp",
      PhoneNumber: "Số điện thoại",
      ExpriedAt: "Ngày hết hạn hợp đồng",
      ExpriedSignDate: "Ngày hết hạn ký",
      VerifiedStatus: "Trạng thái xác thực",
      IsVerified: "Đã xác thực",
      NotVerified: "Chưa xác thực",
      File: "Tài liệu",
      SyncStatus: "Đồng bộ trạng thái hồ sơ",
      SyncAllStatus: "Đồng bộ trạng thái tất cả hồ sơ",
      Organization: {
        Name: "Tổ chức",
        Address: "Địa chi",
        Email: "Email",
        TaxCode: "Mã số thuế",
        Bank: "Ngân hàng",
        RepresentativeName: "Người đại diện",
        RepresentativeRole: "Chức vụ",
        BusinessCerts: "GPĐK kinh doanh",
      },
      Participants: {
        Title: "Thành viên tham gia",
        Name: "Họ tên user",
        Address: "Địa chỉ",
        Email: "Email",
        TaxCode: "Mã số thuế",
        Bank: "Ngân hàng",
        BankAccount: "Số tài khoản",
        Single: "Cá nhân",
        Organization: "Tổ chức",
        Code: "Mã người dùng",
        RecipentCode: "Mã người dùng nhà cung cấp",
        PhoneNumber: "Số điện thoại",
        Type: "Loại",
        Status: "Trạng thái user ký",
        Images: "Hình ảnh",
        IDNumber: "CCCD",
        IdIssueDate: "Ngày cấp",
        IdIssuePlace: "Nơi cấp",
      },
      AssetsClassify: {
        Avatar: "Ảnh đại diện",
        BusinessCerts: "GPĐK kinh doanh",
        Contract: "Hợp đồng",
        IdCard: "CCCD",
        Default: "Hình ảnh",
      },
      Reason: "Lý do",
    },
    Messages: {
      ConfirmAcceptProfile: "Bạn có chắc muốn duyệt hồ sơ này?",
      ConfirmDenyProfile: "Bạn có chắc muốn từ chối hồ sơ này?",
      ConfirmSignProfile: "Bạn có chắc muốn ký hồ sơ?",
    },
    Status: {
      Init: "Khởi tạo",
      Proccessing: "Đang chờ ký",
      Approving: "Đang chờ duyệt",
      Approved: "Đã duyệt",
      Completed: "Hoàn thành",
      Rejected: "Từ chối",
      Cancel: "Đã hủy",
      Signed: "Đã ký",
      Expried: "Hết hạn",
    },
    Type: {
      Verified: "Hợp đồng hợp tác",
    },
  },
  AppTransactionHistory: {
    AppPhoneRechargeTitle: "Nạp tiền điện thoại",
    AppSimMobifoneTitle: "SIM",
    AppDataRegisterTitle: "Gói cước",
    AppNiceSimTitle: "SIM số đẹp",
    AppTravelSimTitle: "SIM Du lịch",
    InboundTravelSimTitle: "Hello Vietnam",
    OutboundTravelSimTitle: "GoGo SIM",
    ExportReportTiTle: "Xuất báo cáo lịch sử giao dịch",
    TransactionHistory: "Lịch sử giao dịch",
    ExportSuccess: "Xuất báo cáo thành công",
    Labels: {
      BuyerPhones: "Số điện thoại người mua",
      UserPhone: "Số điện thoại người thực hiện",
      DetailTrans: "Chi tiết giao dịch",
      Status: "Trạng thái",
      Type: "Loại",
      Name: "Tên sản phẩm",
      PackageCode: "Mã gói",
      SimCode: "Sim",
      PackageName: "Tên gói",
      Code: "Mã giao dịch",
      ReferenceCode: "Mã tham chiếu",
      Time: "Thời gian",
      Service: "Dịch vụ",
      Product: "Sản phẩm",
      ProductCode: "Mã sản phẩm",
      ProductPrice: "Giá sản phẩm",
      PhoneNumber: "Số điện thoại",
      SimNumber: "Số của sim",
      IsdnOrIccid: "Số điện thoại/ICCID",
      PaymentMethod: "Phương thức",
      NumberType: "Loại số",
      Total: "Số tiền",
      TransRef: "Mã tham chiếu",
      Platform: "Nền tảng",
      Description: "Mô tả",
      Nation: "Quốc gia",
      Zodiac: "Cung hoàng đạo",
      Numerology: "Thần số học",
      Destiny: "Mệnh",
      BeforeCredit: "Số dư trước GD",
      AfterCredit: "Số dư sau GD",
      User: "Nguời dùng",
      Serial: "Số Serial",
      CodeAirTime: "Mệnh giá",
      MobileNumber: "Số thuê bao",
      SupplierRefCode: "Mã GD của NCC",
      TransactionCode: "Mã đơn hàng",
      NumberTypeOps: {
        MEMORABLE_PHYSICAL: "Số dễ nhớ",
        THREE_7_PHYSICAL: "Tam hoa 7",
        THREE_8_PHYSICAL: "Tam hoa 8",
        THREE_9_PHYSICAL: "Tam hoa 9",
        AB_BA_PHYSICAL: "Cặp số AB_BA",
        AB_AB_PHYSICAL: "Cặp số AB_AB",
        AA_BB_PHYSICAL: "Cặp số AA_BB",
      },
      AmountLabel: {
        product: "Sản phẩm",
        discount: "Giảm giá",
        userTax: "Thuế",
        discountRate: "Chiết khấu",
        package: "Gói",
        simAdvance: "Phí giữ sim",
      },
      BuyerName: "Khách hàng",
      BuyerEmail: "Email",
      BuyerPhone: "Số điện thoại",
      BuyerAddress: "Địa chỉ",
      UserName: "Người thực hiện",
      UserCode: "Mã người dùng",
      ProductLabels: {
        SimNumber: "Số Sim",
        SimPrice: "Giá Sim",
        SimType: "Loại SIM",
        PackageName: "Gói cước",
        PackageCode: "Mã gói",
        PackagePrice: "Giá gói",
        Storage: "Dung lượng",
        Duration: "Thời hạn",
        Serial: "Số serial",
        Code: "Mã SP",
        Price: "Giá SP",
      },
    },
    Status: {
      Init: "Khởi tạo",
      Process: "Đang xử lý",
      Success: "Thành công",
      Failed: "Thất bại",
      Pending: "Chờ thanh toán",
      PaymentSuccess: "Thanh toán thành công",
      Timeout: "Đang treo",
      Refund: "Đã hoàn tiền",
      Deleted: "Đã xóa",
      Reject: "Bị từ chối",
    },
    Type: {
      Normal: "Mặc định",
      User: "Cá nhân",
      Partner: "Pháp nhân",
    },
    TransactionDetail: {
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
      name: "Tên giao dịch",
      code: "Mã giao dịch",
      transRef: "Mã tham chiếu",
      transactionCode: "Mã giao dịch tham chiếu/đơn hàng",
      phoneNumber: "Số điện thoại",
      serial: "ICCID",
      serialNumber: "Serial",
      packageName: "Tên gói",
      packageCode: "Mã gói",
      status: "Trạng thái",
      totalPrice: "Tổng tiền",
      numberType: "Loại số",
      simType: "Loại SIM",
      type: "Loại giao dịch",
      carrier: "Nhà mạng",
      package: "Gói cước",
      beforeCredit: "Số dư trước giao dịch",
      afterCredit: "Số dư sau giao dịch",
      shippingFee: "Phí vận chuyển",
      description: "Lý do lỗi",
      buyerName: "Tên người mua",
      buyerId: "ID người mua",
      buyerEmail: "Email người mua",
      buyerPhone: "Số điện thoại liên hệ",
      buyerAddress: "Địa chỉ người mua",
      codeAirTime: "Mã gói nạp",
      nameAirTime: "Tên gói nạp",
      partnerCode: "Mã đối tác",
      partnerName: "Tên đối tác",
      providerCode: "Mã nhà cung cấp",
      transactionRef: "Mã tham chiếu giao dịch",
      travelType: "Loại SIM Du lịch",
      userFullName: "Nhân viên thực hiện",
      userName: "Nhân viên thực hiện",
      userPhone: "SĐT thực hiện",
    },
    TransactionLog: {
      TransactionInfo: "Thông tin giao dịch",
      PartnerSystemInfo: "Thông tin đối tác & hệ thống",
      Note: "Ghi chú",
      Title: "Nhật ký giao dịch",
      TotalProcessingTime: "Tổng thời gian xử lý",
      Second: "giây",
      Millisecond: "ms",
      NoData: "Không có thông tin nhật ký giao dịch",
      Dummy: {
        Initialize: "Khởi tạo giao dịch",
        InitializeDescription: "Yêu cầu giao dịch được tạo bởi người dùng",
        Validate: "Xác thực & kiểm tra yêu cầu",
        ValidateDescription: "Xác thực đối tác và kiểm tra tính hợp lệ",
        Create: "Tạo giao dịch hệ thống",
        CreateDescription: "Tạo bản ghi giao dịch trong hệ thống",
        Send: "Gửi yêu cầu đến nhà cung cấp (SMM)",
        SendDescription: "Gửi yêu cầu tạo giao dịch đến NCC",
        Provider: "Nhà cung cấp xử lý",
        ProviderDescription: "Nhà cung cấp trả về lỗi: Order transaction error",
        HandleError: "Xử lý lỗi từ nhà cung cấp",
        HandleErrorDescription: "Hệ thống ghi nhận và xử lý lỗi",
        Update: "Cập nhật trạng thái giao dịch",
        UpdateDescription: "Cập nhật trạng thái giao dịch thành thất bại",
        Notify: "Gửi thông báo kết quả",
        NotifyDescription: "Gửi kết quả giao dịch về cho đối tác",
      },
    },
    RefundModal: {
      Title: "Xác nhận",
      ReasonLabel: "Lý do hoàn tiền",
      ReasonPlaceholder: "Nhập lý do hoàn tiền",
      ReasonRequired: "Vui lòng nhập lý do hoàn tiền",
      ReasonMinLength: "Lý do quá ngắn (tối thiểu 5 ký tự)",
      InfoTextPrefix: "Hoàn tiền cho giao dịch mã giao dịch",
      InfoTextMiddle: "với số tiền",
    },
    ExportReportTransaction: {
      Title: "Xuất báo cáo giao dịch",
    },
  },
  UserAppManagement: {
    Title: "User cá nhân",
    BusinessTitle: "User pháp nhân",
    Verfied: "Đã xác thực ?",
    LoginSession: "Lịch sử đăng nhập App",
    AppVersion: "Phiên bản ứng dụng",
    LastLogin: "Đăng nhập lần cuối",
    Device: "Thiết bị",
    Location: "Vị trí",
    Label: {
      DetailInfo: "Thông tin chi tiết",
      Address: "Địa chỉ",
      CreatedTime: "Thời gian tạo",
      Id: "ID",
      Code: "Mã người dùng",
      UserName: "Tên tài khoản",
      FullName: "Họ tên",
      Email: "Email",
      Partner: "Đối tác",
      Phone: "Số điện thoại",
      Balance: "Số dư",
      Role: "Role",
      Birthday: "Ngày sinh",
      Description: "Mô tả",
      TaxCode: "Mã số thuế",
      LatestContract: "Hồ sơ xác thực",
      ResetOTP: "Đặt lại OTP",
      ChangePassword: "Đổi mật khẩu",
      Note: "Ghi chú",
    },
  },
  TravelSimProfileRegister: {
    Title: "Đăng ký SIM Du lịch",
    Status: {
      Init: "Khởi tạo",
      InProgress: "Đang xử lý",
      Success: "Thành công",
      Error: "Lỗi",
      Confirm: "Đã xác nhận",
      Connect: "Đã kết nối",
      Approve: "Đã duyệt",
    },
    Detail: {
      Buyer: "Người tạo đơn",
      Sim: "Số SIM",
      BuyerEmail: "Email liên lạc",
      BuyerPhone: "SĐT liên lạc",
      BuyerCode: "Mã tài khoản",
      Serial: "Số Serial",
      Time: "Thời gian",
      Title: "Chi tiết GD",
      Code: "Mã",
      IdNumber: "Số Passport",
      Status: "Trạng thái",
      Nationality: "Quốc tịch",
      CodeNumber: "Mã số",
      PlaceOfOrigin: "Nơi sinh",
      IssueDate: "Ngày cấp",
      IssuePlace: "Nơi cấp",
      Profile: "Hồ sơ",
      ExpiryDate: "Ngày hết hạn",
      Note: "Ghi chú",
      DialCode: "Mã quốc gia",
      Documents: "Tài liệu",
      Front: "Mặt trước",
      Back: "Mặt sau",
      Portrait: "Chân dung",
      Sign: "Chữ ký",
      VideoCall: "Video call",
      FrontDownscale: "Mặt trước (thu nhỏ)",
      PortraitDownscale: "Chân dung (thu nhỏ)",
      VideoCallDownscale: "Video call (thu nhỏ)",
      Contract: "Hợp đồng",
      Policy: "Chính sách",
    },
    ImagePaths: {
      portrait: "Ảnh chân dung",
      videocall: "Videocall",
      front: "Mặt trước",
      back: "Mặt sau",
      sign: "Chữ ký",
      sim: "Sim",
      contractId: "Hợp đồng",
      policyId: "Điều khoản bảo mật",
      frontDownscaleId: "Mặt trước thu nhỏ",
      portraitDownscaleId: "Chân dung thu nhỏ",
      videocallDownscaleId: "Video call thu nhỏ",
    },
  },
  PaymentMethod: {
    Label: "Quản lý phương thức thanh toán",
    Total: "Tổng số phương thức thanh toán",
    Columns: {
      id: "ID phương thức",
      name: "Tên phương thức",
      displayName: "Tên hiển thị",
      code: "Mã phương thức",
      type: "Loại",
      status: "Trạng thái",
      order: "Order",
    },
    Filters: {
      name: "Tên phương thức",
      code: "Mã phương thức",
      displayName: "Tên hiển thị",
      type: "Loại",
      status: "Trạng thái",
    },
    Detail: {
      id: "ID",
      name: "Tên phương thức",
      code: "Mã phương thức",
      status: "Trạng thái",
      type: "Loại",
      displayName: "Tên hiển thị",
      supplier: "Nhà cung cấp",
      cover: "Hình ảnh",
      description: "Mô tả",
      url: "Đường dẫn",
      order: "Order",
    },
    Active: {
      1: "Ngân hàng",
      2: "Ví điện tử",
    },
  },
  SupplierManagement: {
    Label: "Quản lý nhà cung cấp",
    Total: "Tổng nhà cung cấp",
    Code: "Mã gói cước nhà cung cấp",
    Columns: {
      id: "ID nhà cung cấp",
      name: "Tên nhà cung cấp",
      displayName: "Tên hiển thị",
      email: "Email",
      phoneNumber: "Số điện thoại",
      address: "Địa chỉ",
      type: "Loại",
      status: "Trạng thái",
    },
    Filters: {
      name: "Tên nhà cung cấp",
      displayName: "Tên hiển thị",
      email: "Email",
      phoneNumber: "Số điện thoại",
      type: "Loại",
      status: "Trạng thái",
    },
    Detail: {
      id: "ID",
      name: "Tên nhà cung cấp",
      status: "Trạng thái",
      type: "Loại",
      displayName: "Tên hiển thị",
      email: "Email",
      phoneNumber: "Số điện thoại",
      address: "Địa chỉ",
      cover: "Hình ảnh",
      image: "Ảnh",
      description: "Mô tả",
      order: "Order",
    },
    Active: {
      0: "Mặc định",
      1: "Thanh toán",
      2: "OCR",
    },
  },
  AirTimeManagement: {
    Label: "Mệnh giá nạp ĐT",
    Total: "Tổng cộng",
    Columns: {
      id: "ID mệnh giá",
      name: "Tên mệnh giá",
      code: "Mã mệnh giá",
      amount: "Giá trị (VND)",
      type: "Loại",
      status: "Trạng thái",
    },
    Filters: {
      name: "Tên mệnh giá",
      code: "Mã mệnh giá",
      amount: "Giá trị",
      carrier: "Nhà mạng",
      type: "Loại",
      status: "Trạng thái",
    },
    Detail: {
      name: "Tên mệnh giá",
      code: "Mã mệnh giá",
      amount: "Giá trị",
      status: "Trạng thái",
      type: "Loại",
      carrier: "Nhà mạng",
      config: "Cấu hình",
      description: "Mô tả",
    },
    Supplier: {
      name: "Tên nhà cung cấp",
      displayName: "Tên hiển thị",
      address: "Địa chỉ",
      email: "Email",
      phoneNumber: "Số điện thoại",
      description: "Mô tả",
    },
    Type: {
      0: "Thẻ điện thoại",
    },
    Message: {
      name: "Vui lòng nhập tên...",
      code: "Vui lòng nhập mã...",
      amount: "Nhập giá trị ít nhất 1,000 VND",
      status: "Chọn trạng thái...",
      type: "Chọn loại...",
      carrier: "Chọn nhà mạng...",
      config: "Nhập cấu hình...",
      description: "Nhập mô tả...",
    },
  },
  DiscountManagement: {
    Title: "Chiết khấu",
    CreateDiscount: "Tạo chiết khấu",
    UpdateDiscount: "Cập nhật chiết khấu",
    Columns: {
      id: "ID",
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
      name: "Tên chiết khấu",
      code: "Mã chiết khấu",
      type: "Loại chiết khấu",
      order: "Order",
      note: "Ghi chú",
      discountRate: "Chiết khấu",
      parentId: "Thuộc nhóm chiết khấu",
      service: "Dịch vụ",
      group: "Nhóm sản phẩm",
      product: "Sản phẩm",
      parent: "Chiết khấu cha",
      child: "Chiết khấu con",
      parentCode: "Mã chiết khấu cha",
      parentRate: "Mức chiết khấu cha",
      AddNewUser: "Thêm người dùng",
    },
    Filters: {
      status: "Trạng thái",
      type: "Loại",
      user: "Người dùng",
      service: "Dịch vụ",
      group: "Nhóm sản phẩm",
    },
    Messages: {
      Required: "Vui lòng điền thông tin này",
      DeleteConfirm: 'Bạn có muốn xóa "{name}" không?',
    },
  },
  SimManagement: {
    Title: "Quản lý Sim",
    DownloadTemplate: "Tải mẫu nhập sim",
    UploadFile: "Upload phiếu nhập sim",
    ImportSim: "Nhập sim",
    ImportTable: "Nhập sim trực tiếp",
    ImportFile: "Nhập sim từ file",
    ImportSuccess: "Nhập sim thành công",
    AddRow: "Thêm hàng",
    QuickUpdate: "Bạn có muốn cập nhật nhanh không?",
    ErrorMessage1: "Phiếu bạn vừa nhập hiện có",
    ErrorMessage2: "dòng bị lỗi",
    SimDetail: "Thông tin Sim",
    Status: {
      Active: "Khả dụng",
      Inactive: "Không khả dụng",
      Sold: "Đã bán",
      Deleted: "Đã xóa",
    },
    SimType: {
      Physical: "SIM Vật lý",
      ESim: "eSIM",
    },
    Fields: {
      Code: "Mã định danh",
      Name: "Tên hiển thị",
      Serial: "Serial",
      PhoneNumber: "Số sim",
      Status: "Trạng thái",
      Type: "Dịch vụ",
      SimType: "Loại SIM",
      SKU: "Mã SKU",
      Zodiac: "Cung hoàng đạo",
      Numerology: "Thần số học",
      Destiny: "Mệnh",
      Description: "Mô tả",
      ShortDescription: "Mô tả ngắn",
    },
  },
  AppFeedback: {
    Title: "Yêu cầu hỗ trợ",
    Detail: "Chi tiết yêu cầu",
    Labels: {
      Code: "Mã hồ sơ",
      Phone: "Số điện thoại",
      OS: "OS",
      Device: "Thiết bị",
      AppVersion: "Phiên bản ứng dụng",
      AppCode: "Mã ứng dụng",
      CreatedAt: "Ngày tạo",
      Description: "Mô tả",
      Note: "Ghi chú",
      File: "File",
      Logs: "Logs",
      User: "Người dùng",
    },
  },
  SupportFeature: {
    MainTitle: "Hỗ trợ",
    PackageLookup: {
      Title: "Tra cứu gói cước",
      Input: {
        Placeholder: "Nhập số thuê bao",
      },
      Output: {
        StartDate: "Ngày kích hoạt",
        EndDate: "Ngày kết thúc",
        Capacity: "Dung lượng",
        UsedCapacity: "Dung lượng đã sử dụng",
        RemaingCapacity: "Dung lượng còn lại",
        Package: "Tên gói cước",
        PackageCapacity: "Dung lượng gói cước",
        NotFound: "Số điện thoại này chưa đăng ký gói cước",
      },
    },
    SimLookup: {
      Title: "Tra cứu SIM",
      Input: {
        Placeholder: "Nhập Serial/ICCID",
        QRCode: "QRCode SIM",
      },
      Errors: {
        Required: "Vui lòng nhập Serial/ICCID",
        Invalid: "ICCID phải gồm 18–20 ký tự hoặc Serial gồm 10–17 ký tự",
        NotFound: "SIM không tồn tại",
        ServiceBusy: "Dịch vụ tra cứu SIM đang bận. Vui lòng thử lại sau",
        Unavailable: "Dịch vụ tra cứu SIM hiện không khả dụng",
        Failed: "Tra cứu thông tin SIM thất bại",
        Unauthorized: "Bạn không có quyền tra cứu SIM này",
      },
      Output: {
        isActivated: "SIM đã được kích hoạt",
        isUnactivated: "SIM chưa được kích hoạt",
        isNotExist: "SIM không tồn tại trong hệ thống",
        UsageManagement: "Quản lý dung lượng",
        Remaining: "Còn lại",
        Unlimited: "Không giới hạn",
        UsedData: "Đã sử dụng",
        TotalData: "Tổng dung lượng",
        PackageInfo: "Thông tin gói cước",
        InUse: "Đang sử dụng",
        Expired: "Đã hết hạn",
        Ready: "Chờ quét mã",
        ActiveUnused: "Đã kích hoạt - chưa sử dụng",
        Disabled: "Đã tắt",
        Terminated: "Đã kết thúc",
        NotActivated: "Chưa kích hoạt",
        UnknownStatus: "Không xác định",
        ReadyMessage: "Chưa tải eSIM và đang chờ quét mã.",
        ActiveUnusedMessage:
          "Đã cài đặt thành công, đang kết nối data nhưng chưa phát sinh lưu lượng.",
        ActivatedMessage: "Đã kích hoạt và đang phát sinh lưu lượng data.",
        DisabledMessage: "Đã bị tắt trong cài đặt máy.",
        TerminatedMessage: "Đã hết hạn hoặc đã sử dụng hết dung lượng.",
        ActivatedAt: "Thời gian kích hoạt",
        PlanExpireDate: "Hạn dùng gói cước",
        ActivationExpireDate: "Hạn chót kích hoạt",
        FindIccidTitle: "Cách tìm mã ICCID của bạn",
        ESimGuide:
          "Kiểm tra trong email đơn hàng nhận mã QR eSIM, hoặc trên điện thoại vào Cài đặt > Di động > chọn eSIM > tìm mục ICCID.",
        PhysicalSim: "SIM vật lý",
        PhysicalSimGuide:
          "Dãy số ICCID được in trực tiếp ở mặt sau của thẻ SIM vật lý.",
        CopyIccid: "Sao chép ICCID",
        CopySuccess: "Đã sao chép ICCID",
      },
      Message: {
        NumberOrQr: "Vui lòng nhập ICCID hoặc tải ảnh QRCode SIM.",
      },
    },
    ApiDoc: {
      Title: "Tài liệu hỗ trợ API",
      Add: "Thêm",
      AddDocument: "Thêm tài liệu ngay",
      EmptyTitle: "Chưa có tài liệu nào",
      EmptyDescription:
        "Dịch vụ này hiện chưa có tài liệu API hoặc hướng dẫn nào được tải lên.",
      DeleteTitle: "Xóa tài liệu",
      DownloadFailed: "Tải file thất bại. Vui lòng thử lại.",
      UploadModalTitle: "Upload File mới",
      ServiceLabel: "Dịch vụ",
      ServicePlaceholder: "Chọn dịch vụ",
      ServiceRequired: "Vui lòng chọn dịch vụ!",
      FileLabel: "File tài liệu",
      FileRequired: "Vui lòng chọn file!",
      FileLimitError: "Dung lượng file không được vượt quá 10MB!",
      FileLimitExceeded: "Dung lượng file vượt quá giới hạn 10MB!",
      DraggerText: "Click hoặc kéo file vào khu vực này",
      DraggerHint:
        "Hỗ trợ: PDF, Office, JSON, YAML, ZIP, hình ảnh... (Tối đa 10MB)",
      FileNameLabel: "Tên hiển thị file",
      FileNamePlaceholder: "Nhập tên hiển thị file",
      FileNameRequired: "Vui lòng nhập tên hiển thị file!",
      FileSize: "Dung lượng:",
    },
    Dispatch: {
      Title: "Văn bản",
      Add: "Thêm",
      AddDocument: "Thêm văn bản ngay",
      EmptyTitle: "Chưa có văn bản nào",
      EmptyDescription:
        "Dịch vụ này hiện chưa có văn bản hoặc công văn nào được tải lên.",
      DeleteTitle: "Xóa văn bản",
      DownloadFailed: "Tải file thất bại. Vui lòng thử lại.",
      UploadModalTitle: "Upload Văn bản mới",
      ServiceLabel: "Dịch vụ",
      ServicePlaceholder: "Chọn dịch vụ",
      ServiceRequired: "Vui lòng chọn dịch vụ!",
      FileLabel: "File văn bản",
      FileRequired: "Vui lòng chọn file!",
      FileLimitError: "Dung lượng file không được vượt quá 10MB!",
      FileLimitExceeded: "Dung lượng file vượt quá giới hạn 10MB!",
      DraggerText: "Click hoặc kéo file vào khu vực này",
      DraggerHint:
        "Hỗ trợ: PDF, Office, JSON, YAML, ZIP, hình ảnh... (Tối đa 10MB)",
      FileNameLabel: "Tên hiển thị file",
      FileNamePlaceholder: "Nhập tên hiển thị file",
      FileNameRequired: "Vui lòng nhập tên hiển thị file!",
      FileSize: "Dung lượng:",
    },
  },
  CashFlow: {
    MainTitle: "Dòng tiền",
    Columns: {
      TransCode: "Mã giao dịch",
      CostIn: "Tiền vào",
      CostOut: "Tiền ra",
      Wallet: "Số dư cuối",
      Content: "Nội dung",
      Total: "Số tiền",
    },
    Filters: {
      Type: "Nội dung",
      Code: "Mã giao dịch",
      Debit: "Trừ tiền",
      Withdraw: "Rút tiền",
      Deposit: "Nạp tiền",
      Refund: "Hoàn tiền",
    },
    Type: {
      0: "Trừ tiền",
      1: "Rút tiền",
      2: "Nạp tiền",
      3: "Hoàn tiền",
    },
  },
  StaffManagement: {
    Title: "Quản lý tài khoản",
    MainTitle: "Người dùng",
  },
  StoreManagement: {
    Title: "Cửa hàng",
    Labels: {
      Code: "Mã cửa hàng",
      Phone: "Số điện thoại",
      Chain: "Chuỗi",
      Status: "Trạng thái",
      Name: "Tên cửa hàng",
      Email: "Email",
      Description: "Mô tả",
      Balance: "Số dư",
      Note: "Ghi chú",
      Address: "Địa chỉ",
      StoreHeader: "Trưởng cửa hàng",
      StoreHeaderPhone: "SĐT trưởng cửa hàng",
      UsersInStore: "Người dùng thuộc cửa hàng",
    },
    Messages: {
      DeleteConfirm: 'Bạn có muốn xóa cửa hàng "{name}" không?',
    },
  },
  ErrorCodeManagement: {
    Title: "Quản lý mã lỗi",
    Columns: {
      name: "Tên mã",
      code: "Mã lỗi",
      service: "Dịch vụ",
      source: "Nguồn mã lỗi",
      message: "Nội dung vắn tắt",
      description: "Nội dung đầy đủ",
      type: "Loại mã",
      status: "Trạng thái",
      createdAt: "Ngày tạo",
    },
    Detail: {
      createdAt: "Ngày tạo",
      name: "Tên lỗi",
      code: "Mã lỗi",
      source: "Nguồn mã lỗi",
      service: "Dịch vụ",
      message: "Nội dung vắn tắt",
      description: "Nội dung đầy đủ",
      note: "Mô tả lỗi",
      order: "Order",
      type: "Loại mã",
      status: "Trạng thái",
    },
    Filters: {
      code: "Mã lỗi",
      message: "Nội dung vắn tắt",
      description: "Nội dung đầy đủ",
      source: "Nguồn mã lỗi",
      note: "Mô tả lỗi",
      type: "Loại mã",
      status: "Trạng thái",
    },
    ErrorType: {
      0: "Thiếu dữ liệu đầu vào",
      1: "Sai dữ liệu đầu vào",
      2: "Lỗi logic nghiệp vụ",
      3: "Lỗi bảo mật/xác thực",
      4: "Lỗi server/kết nối",
      5: "Lỗi cấu hình",
      6: "Lỗi logic code",
    },
    Source: ["SMM", "B2C", "B2B", "Neci"],
  },
  B2BAccount: {
    Title: "Tài khoản B2B",
    Labels: {
      Phone: "Số điện thoại",
      Partner: "Đối tác",
      Status: "Trạng thái",
      Name: "Họ tên",
      Username: "Username",
      Email: "Email",
      Description: "Mô tả",
      Balance: "Số dư",
      Note: "Ghi chú",
      Address: "Địa chỉ",
    },
  },
  B2BPartner: {
    Title: "Đối tác B2B",
    Labels: {
      Name: "Tên đối tác",
      DisplayName: "Tên hiển thị",
      Code: "Mã đối tác",
      Status: "Trạng thái",
      Description: "Mô tả",
      Balance: "Số dư",
      Address: "Địa chỉ",
      Website: "Trang web",
    },
  },
  B2BPackageManagement: {
    TotalTitle: "Tổng số gói cước",
    SupplierCode: "Thông tin nhà cung cấp",
    Setting: "Điều chỉnh",
    MainTitle: "Danh sách gói cước",
    MerchantInventoryLabel: "Ngăn kho đối tác",
    AddNewPackage: "Thêm gói mới",
    DeletePackageConfirm: "Bạn có muốn xóa gói cước này?",
    DetailModalTitle: "Thông tin gói cước",
    AddNewModalTitle: "Thêm gói cước mới",
    AddNewDescription: "Thêm mô tả",
    SMS: "Nạp SMS",
    Direct: "Nạp trực tiếp",
    InventoryType: "Loại ngăn kho",
    HighPriority: "Độ ưu tiên cao",
    LowPriority: "Độ ưu tiên thấp",
    Channel: {
      Title: "Kênh",
      TTC: "Trung tâm cước",
    },
    Titles: {
      IndexNumber: "STT",
      PackageCode: "Mã gói",
      PackageName: "Tên gói",
      Type: "Loại gói",
      Group: "Nhóm gói",
      DurationDay: "Thời gian gói (ngày)",
      Price: "Giá (VND)",
      MinPrice: "Giá nhỏ nhất",
      MaxPrice: "Giá lớn nhất",
      Status: "Trạng thái",
      Action: "Hành động",
      Supplier: "Nhà cung cấp",
      SupplierCode: "Mã tham chiếu của nhà cung cấp",
      Description: "Mô tả",
      Discount: "Giảm giá",
      OnlyData: "Only Data ?",
      JustData: "Chỉ có Data",
      DataAndCall: "Data và Thoại",
      Image: "Hình gói",
      ImagePlaceholder: "Nhập link ảnh",
      TopUpMethod: "Phương thức nạp",
      RemoveDescription: "Xóa mô tả",
      Inventories: "Ngăn kho",
    },
    Details: {
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
      id: "ID gói",
      name: "Tên gói",
      code: "Mã gói",
      durationDay: "Thời lượng",
      price: "Giá gói",
      topupMethod: "Phương thức nạp",
      discountRate: "Giảm giá",
      type: "Loại gói",
      status: "Trạng thái",
      mobileDataGroup: "Nhóm gói",
    },
    MerchantInventory: {
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
      id: "ID",
      name: "Tên",
      code: "Mã",
      balance: "Hạn mức",
      maxBalance: "Hạn mức tối đa",
      type: "Loại",
      status: "Trạng thái",
      merchant: "Đối tác",
    },
    SupplierCodes: {
      id: "ID",
      order: "Độ ưu tiên",
      type: "Kênh",
      status: "Trạng thái",
      supplier: "Nhà cung cấp",
      merchantInventory: "Thông tin ngăn kho",
    },
    Messages: {
      AtLeastOneDescription: "Phải có ít nhất một ý mô tả!",
      TopupMethodSectionMessage: "Vui lòng chọn phương thức Topup",
      GroupSelectionMessage: "Vui lòng chọn nhóm gói cước!",
      TypeSelectionMessage: "Vui lòng chọn loại gói cước!",
      StatusSelectionMessage: "Vui lòng chọn loại trạng thái gói",
      ImageMessage:
        "Vui lòng nhập ảnh bằng link http:// chứa đuôi png, jpg hoặc jpeg",
      ImageError: "Link bạn vừa nhập không phải link ảnh, vui lòng nhập lại!",
      Price: "Vui lòng chọn giá ít nhất 1,000 VND",
      SetPrioritySuccess: "Điều chỉnh độ ưu tiên thành công",
      SetPriorityFailed: "Điều chỉnh độ ưu tiên thất bại",
      DeleteInventoryConfirm: "Bạn có muốn xóa tất cả ngăn kho được chọn?",
      AddPackageConfirm: "Bạn có muốn thoát tiến trình tạo gói không?",
      SelectSupplierMessage:
        "Vui lòng chọn nhà cung cấp trước khi thêm ngăn kho.",
      InventoriesRequired: "Vui lòng thêm ngăn kho",
      OnlyForWarehouse:
        "Tính năng này chỉ dành cho nhà cung cấp là 'Warehouse'",
      ChangeSupplier: "Thay đổi nhà cung cấp",
      ClearInventories:
        "Lưu ý: Thay đổi nhà cung cấp sẽ xóa các ngăn kho đã thêm.",
      DurationDay: "Nhập số ngày ít nhất từ 1 ngày trở lên",
    },
    TopupMethodList: {
      Live: "Trực tiếp",
      SMS: "SMS",
    },
    StatusList: {
      Actived: "Kích hoạt",
      Deactived: "Không kích hoạt",
      Deleted: "Đã xóa",
    },
    TypeList: {
      Normal: "Normal",
      Flexible: "Flexible",
      Hourly: "Hourly",
      Roaming: "Roaming",
    },
    DurationDayList: {
      "1_Day": "1 ngày",
      "3_Days": "3 ngày",
      "7_Days": "7 ngày",
      "10_Days": "10 ngày",
      "15_Days": "15 ngày",
      "30_Days": "30 ngày",
    },
    Inventories: {
      AddInventory: "Thêm ngăn kho",
      EditInventory: "Sửa ngăn kho",
      ManualAddition: "Thủ công",
      FindFromWarehouse: "Từ Warehouse",
      Excel: "File Excel",
    },
    InventoryColumns: {
      Code: "Mã ngăn kho",
      Name: "Tên ngăn kho",
      SKU: "SKU",
      Merchant: "Đối tác",
      Balance: "Hạn mức",
      MaxBalance: "Hạn mức tối đa",
      Status: "Trạng thái",
      Type: "Loại",
      Order: "Độ ưu tiên",
      Channel: "Kênh",
      Method: "Phương thức thêm",
    },
    InventoryStatusList: {
      Active: "Kích hoạt",
      Deactive: "Chưa kích hoạt",
    },
    InventoryChannelList: {
      WH3: "Warehouse 3",
      WHN: "Warehosue New",
    },
    InventoryOrderList: {
      High: "Cao",
      Low: "Thấp",
    },
    InventoryTypeList: {
      Normal: "Bình thường",
    },
  },
  OscLookupFeature: {
    SubTitle: "Hỗ trợ",
    Title: "Tra cứu thuê bao IoT (đơn lẻ)",
    EmptyResult: "Nhập số thuê bao/Serial và nhấn 'Tra cứu' để xem thông tin",
    Searching: "Đang tra cứu thuê bao",
    Labels: {
      phoneNumber: "Số thuê bao",
      serial: "Serial",
      status: "Trạng thái kích hoạt",
      subscriberStatus: "Trạng thái thuê bao",
      isdnType: "Loại thuê bao",
      simType: "Loại SIM",
      device: "Thiết bị",
      imei: "Mã nhận dạng thiết bị di động quốc tế (IMEI)",
      packageName: "Tên gói cước",
      startDate: "Ngày đăng ký gói",
      endDate: "Ngày hết hạn",
      serviceName: "Mã gói cước",
      total: "Dung lượng gói",
      dataUsed: "Dung lượng đã sử dụng",
      remaining: "Dung lượng còn lại",
    },
    Status: {
      Activated: "Đã kích hoạt",
      NotActivated: "Chưa kích hoạt",
      Active: "Đang hoạt động",
      Inactive: "Không hoạt động",
    },
    Types: {
      Prepaid: "Trả trước",
      Postpaid: "Trả sau",
      PhysicalSim: "SIM vật lý",
      ESim: "eSIM",
    },
    Messages: {
      LookupSuccessfully: "Tra cứu thuê bao thành công",
      LookupFailed: "Số thuê bao/Serial không tìm thấy hoặc không tồn tại",
      PhoneNumber: "Nhập số thuê bao...",
      Serial: "Nhập mã Serial...",
      NoPackageInfo: "Không có thông tin gói cước",
      NoPackageInfoDescription:
        "Thuê bao hiện không có gói cước đang hoạt động hoặc chưa có dữ liệu hiển thị.",
    },
  },
  IOTSimListLookup: {
    Title: "Tra cứu danh sách IoT",
    MainTitle: "Hỗ trợ",
    Labels: {
      Search: "Tra cứu",
      ExportExcel: "Xuất Excel",
    },
    Messages: {
      ExportSuccess: "Xuất Excel thành công",
      NoDataToExport: "Không có dữ liệu để xuất Excel",
      PleaseSelectFile: "Vui lòng chọn tệp tin Excel để tra cứu",
    },
    Uploader: {
      FolderIncoming: "Thư mục Excel đang nhập",
      ChooseAnother: "Chọn 1 tệp tin khác",
      DragDropHint: "Kéo và thả tệp tin Excel của bạn ở bất cứ chỗ nào ở đây",
      Or: "Hoặc",
      ChooseFile: "Chọn 1 tệp tin",
      DropHere: "Thả tệp Excel vào đây",
      DownloadTemplate: "Tải template",
    },
    Status: {
      Active: "Đã kích hoạt",
      Inactive: "Chưa kích hoạt",
    },
    SubscriberStatus: {
      Active: "Đang hoạt động",
      InActive: "Đã hủy",
    },
    IsdnType: {
      Prepaid: "Trả trước",
      Postpaid: "Trả sau",
    },
    SimType: {
      SIM: "SIM vật lý",
      eSIM: "eSIM",
    },
    Columns: {
      PhoneNumber: "Số thuê bao",
      Serial: "Seri Sim",
      SubscriberStatus: "Trạng thái thuê bao",
      PackageName: "Tên gói cước",
      StartDate: "Ngày đăng ký gói",
      EndDate: "Ngày hết hạn gói",
      TotalData: "Dung lượng gói",
      DataUsed: "Đã sử dụng",
      DataRemaining: "Còn lại",
      Device: "Thiết bị sử dụng",
      ActivationStatus: "Trạng thái kích hoạt",
      IsdnType: "Loại thuê bao",
      SimType: "Loại Sim",
    },
  },
  ESimplifiedBuyingBeta: {
    MainTitle: "Hỗ trợ",
    Title: "Mua eSIM Data",
    ResultTitle: "Thông tin đơn hàng",
    Labels: {
      PartnerKey: "Partner Key",
      PartnerKeyPass: "Partner Key Pass",
      TransRef: "Mã tham chiếu",
      Package: "Gói cước",
      PackageCode: "Mã gói cước",
      PhoneNumberCode: "Mã số thuê bao",
      SimType: "Loại SIM",
      Invoice: "Xuất hóa đơn",
      CustomerName: "Tên khách hàng",
      CustomerPhone: "Số điện thoại khách hàng",
      CustomerEmail: "Email khách hàng",
      CustomerAddress: "Địa chỉ khách hàng",
      Refresh: "Làm mới",
      Buy: "Mua hàng",
      Code: "Mã đơn hàng",
      SimCode: "Mã SIM",
      QrCode: "QR Code",
      Serial: "Serial",
      PhoneNumber: "Số thuê bao",
    },
    Placeholders: {
      PartnerKey: "Nhập partner key...",
      PartnerKeyPass: "Nhập partner key pass...",
      TransRef: "Nhập mã tham chiếu...",
      Package: "Chọn gói cước...",
      PackageCode: "Chọn mã gói cước...",
      PhoneNumberCode: "Nhập mã số thuê bao...",
      SimType: "Chọn loại SIM...",
      Invoice: "Chọn trạng thái xuất hóa đơn...",
      CustomerName: "Nhập tên khách hàng...",
      CustomerPhone: "Nhập số điện thoại khách hàng...",
      CustomerEmail: "Nhập email khách hàng...",
      CustomerAddress: "Nhập địa chỉ khách hàng...",
    },
    Options: {
      ESim: "eSIM",
    },
    Messages: {
      OrderSuccessfully: "Mua hàng thành công",
      EmptyResult: "Nhập thông tin và nhấn 'Mua hàng' để xem kết quả",
    },
  },
  ActionLog: {
    Columns: {
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
      name: "Tên",
      code: "Mã",
      type: "Loại",
      status: "Trạng thái",
      note: "Ghi chú",
      order: "Thứ tự",
      path: "Đường dẫn",
      user: "Người thực hiện",
    },
    Status: {
      Active: "Hoạt động",
      InActive: "Không hoạt động",
      Deleted: "Đã xóa",
    },
    Types: {
      0: "Mặc định",
    },
    Filters: {
      search: "Từ khóa",
      status: "Trạng thái",
      type: "Loại",
      path: "Đường dẫn",
      user: "Người thực hiện",
    },
    Placeholders: {
      search: "Nhập từ khóa (tên, mã)...",
      status: "Chọn trạng thái...",
      type: "Chọn loại...",
      path: "Nhập đường dẫn...",
      user: "Chọn người thực hiện...",
    },
    Users: {
      username: "Tài khoản",
      name: "Tên",
      code: "Mã",
      type: "Loại",
      status: "Trạng thái",
    },
  },
  AlertSupport: {
    SubTitle: "Hỗ trợ",
    Title: "Cảnh báo IoT",
    LoadingTitle: "Đang tải danh sách cảnh báo",
    TotalTitle: "Tổng",
    Detail: {
      Title: "Chi tiết cảnh báo",
    },
    Filters: {
      RemainingDays: {
        Title: "Theo ngày sử dụng",
        Description:
          "Gửi thông báo khi số ngày còn lại của gói đạt các mốc sau:",
        Unit: " ngày",
      },
      RemainingCapacity: {
        Title: "Cảnh báo theo dung lượng Data còn lại",
        Description:
          "Gửi thông báo khi dung lượng còn lại của gói đạt các ngưỡng sau:",
        Unit: "%",
      },
    },
    Columns: {
      phoneNumber: "Số thuê bao",
      numberOfDaysRemainingUntilExpiration: "Số ngày hết hạn còn lại",
      capacity: "Dung lượng gói",
      remainingCapacity: "Dung lượng còn lại",
      remainingPercentageCapacity: "% dung lượng còn lại",
    },
  },
};
